<div class="data-convention-update" [formGroup]="form">
  <mat-form-field appearance="outline" class="formField">
    <mat-label>Dimensions order</mat-label>
    <mat-select formControlName="dimensionOrder">
      @for (order of allDimensionOrders; track order) {
        <mat-option [value]="order">{{ orderLabel(order) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="formField">
    <mat-label>Dimension unit</mat-label>
    <mat-select formControlName="dimensionUnit">
      @for (unit of allDimensionUnits; track unit) {
        <mat-option [value]="unit">{{ unit }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="formField">
    <mat-label>Weight unit</mat-label>
    <mat-select formControlName="weightUnit">
      @for (unit of allWeightUnits; track unit) {
        <mat-option [value]="unit">{{ unit }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="preview-block">
    <span class="field-label">Preview</span>
    <pre class="preview-json">{{ previewJson }}</pre>
  </div>
</div>
